/**
 * Types for Aggregated Client Documents (Frontend)
 */

export enum DocumentSourceType {
  CLIENT = 'CLIENT',
  CASE = 'CASE',
  TASK = 'TASK',
  INTERACTION = 'INTERACTION',
  FINANCE = 'FINANCE'
}

export interface AggregatedClientDocument {
  id: string;
  fileName: string;
  filePath: string;
  fileSize: number;
  mimeType: string;

  sourceType: DocumentSourceType;
  sourceEntityId: string;
  sourceEntityName: string;
  sourceEntityNumber?: string;

  documentType: string;
  isConfidential: boolean;
  tags?: string[];

  uploadedBy: string;
  uploadedByName: string;
  uploadedAt: Date | string;
  description?: string;

  clientId: string;
  clientName: string;

  metadata?: Record<string, unknown>;
}

export interface GroupedCaseDocuments {
  caseId: string;
  caseNumber: string;
  caseTitle: string;
  caseArea?: string;
  documents: AggregatedClientDocument[];
}

export interface GroupedDocuments {
  CLIENT: AggregatedClientDocument[];
  CASE: GroupedCaseDocuments[];
  TASK: AggregatedClientDocument[];
  INTERACTION: AggregatedClientDocument[];
  FINANCE: AggregatedClientDocument[];
}

export interface DocumentStats {
  total: number;
  totalSize: number;
  totalBySource: Record<DocumentSourceType, number>;
  totalByType: Record<string, number>;
  confidentialCount: number;
  recentCount: number;
}

export interface AggregatedDocumentsResponse {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  documents: AggregatedClientDocument[];
  groupedBy?: GroupedDocuments;
  stats: DocumentStats;
}

export interface DocumentFiltersState {
  sourceTypes: DocumentSourceType[];
  documentTypes: string[];
  search: string;
  onlyConfidential: boolean;
  startDate: Date | null;
  endDate: Date | null;
  sortBy: 'date' | 'name' | 'type' | 'size';
  sortOrder: 'asc' | 'desc';
}

export type ViewMode = 'grouped' | 'flat' | 'timeline';

export interface SavedFilter {
  id: string;
  name: string;
  filters: Partial<DocumentFiltersState>;
  createdAt: Date;
}
